import { PdfLayerGroup } from './pdf-handling.lib';

export type DrawingLocalStorage = {
  opacity: number;
  activeIndex: number;
  viewConfigs: string;
  pdfLayerGroups: Record<string, PdfLayerGroup>;
}

export function saveDrawingLocalStorage(key: string, data: Partial<DrawingLocalStorage>) {
  const existingData = getDrawingLocalStorage(key);

  localStorage.setItem(key, JSON.stringify({...(existingData ?? {}), ...data}));
}

export function getDrawingLocalStorage(key: string): Partial<DrawingLocalStorage> | null {
  const data = localStorage.getItem(key);

  if (data) {
    return JSON.parse(data);
  } else {
    return null;
  }
}
